const deferCallback = (callback: (args: any) => void) => (args: any) =>
  setTimeout(() => {
    callback(args);
  }, 0);

export default deferCallback;
